import type { ReactNode } from 'react';
import { Flex, Typography, theme } from 'antd';

/**
 * O cabeçalho das telas de autenticação: uma frase e uma linha de explicação.
 *
 * É a construção que a Voa usa, e o que ela resolve é concreto: **um formulário
 * sem frase é um formulário anônimo**. Quem chega de um link de WhatsApp
 * precisa saber, antes de digitar, que está no lugar certo e o que ganha ao
 * continuar - e o logotipo sozinho não diz a segunda parte.
 *
 * As quatro telas do fluxo usam este mesmo bloco para que a passagem entre elas
 * não pareça troca de produto: a pessoa vai de "entrar" para "criar conta" e de
 * volta várias vezes, e o que muda tem de ser só o texto.
 */
export function TituloDaTela({ titulo, descricao }: { titulo: ReactNode; descricao?: ReactNode }) {
  const { token } = theme.useToken();

  return (
    <Flex vertical gap={token.marginXXS}>
      {/*
        `level={2}` e não um tamanho escrito à mão: a escala tipográfica é do
        tema, e fixar 30px aqui deixaria este título fora de qualquer ajuste
        futuro da base.
      */}
      <Typography.Title level={2} style={{ margin: 0 }}>
        {titulo}
      </Typography.Title>

      {descricao ? <Typography.Text type="secondary">{descricao}</Typography.Text> : null}
    </Flex>
  );
}
